export default "__VITE_ASSET__CabM7kOP__"